exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.unitClientImage {\n  height: 90px;\n  margin-right: 15px;\n  width: 60px;\n}\n.unitClientInfo {\n  height: 100%;\n}\n.unitClientInfoContainer {\n  margin: 10px;\n  width: 260px;\n}\n.unitClientName {\n  font-weight: 700;\n}\n.unitClientRoomName {\n  font-style: italic;\n}\n.unitImagesName {\n  color: #39b54a;\n  font-size: 14px;\n  font-weight: 700;\n}\n", ""]);

// exports
